<template>
  <div class="search-result department-dialog-search-result" @scroll="onSearchResultScroll">
    <div id="title" class="title">企业通讯录</div>
    <div id="member-list" class="member-list">
      <label v-for="(item, index) in searchMembers" :key="`${index}${item.userid}`" class="member-info">
        <div class="member-avatar"><img class="avatar-img" :src="item.avatar"></div>
        <div class="member-name-wrap">
          <div class="member-name" :title="item.name" :class="{'only-member-name': getMemberDept(item.dept) === ''}" v-html="getHighlightText(item.name)" />
          <div class="member-dept-path" v-html="getMemberDept(item.dept)" />
        </div>
        <div class="member-checkbox">
          <el-checkbox v-model="item.isChecked" :disabled="checkDisabledUser(item.id)" @change="onMemberCheck(item)" />
        </div>
      </label>
      <div v-show="loading && searchMembers.length" class="search-loading">加载中</div>
    </div>
    <div v-if="!loading && keyword && !searchMembers.length" class="no-result">未搜索到匹配的联系人</div>
  </div>
</template>

<script>
export default {
  name: 'SearchMemberList',
  props: {
    searchMembers: {
      type: Array,
      default: () => Array.from({ length: 0 })
    },
    disabledUserIds: {
      type: Array,
      default: () => Array.from({ length: 0 })
    },
    keyword: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    checkDisabledUser (id) {
      return this.disabledUserIds.includes(id)
    },
    onSearchResultScroll (e) {
      this.$emit('onSearchResultScroll', e)
    },
    onMemberCheck (data) {
      this.$emit('onMemberCheck', data)
    },
    getHighlightText (matchText) {
      const reg = new RegExp(this.keyword.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'))
      return matchText.replace(reg, `<em class="highlight-text">${this.keyword}</em>`)
    },
    getMemberDept (dept) {
      const arr = dept.split('/').slice(1).slice(-2)
      return arr.map(i => `<span class="member-dept">${i}</span>`).join('/')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../style/mixin.scss";
.search-result {
  position: relative;
  overflow-y: auto;
  height: 405px;
  padding-right: 10px;
  .title {
    height: 30px;
    line-height: 30px;
    margin-bottom: 10px;
  }
  .member-list {
    width: 250px;
  }
  .member-info {
    display: flex;
    line-height: 46px;
    height: 46px;
    padding: 0 10px;
    &:hover {
      background: #fafcff;
      cursor: default;
    }
    @import '../style/member-avatar.scss';
    .member-name-wrap {
      vertical-align: middle;
      flex: 1 0 auto;
      position: relative;
      & > div {
        max-width: 100%;
        position: absolute;
        display: inline-block;
        word-wrap: normal;
        @include textOverflow;
      }
      .member-name {
        top: 4px;
        height: 20px;
        line-height: 20px;
        &.only-member-name {
          height: 40px;
          line-height: 40px;
        }
      }
      .member-dept-path {
        top: 25px;
        display: inline-flex;
        height: 17px;
        line-height: 17px;
        font-size: 12px;
        color: #949aae;
      }
    }
    .member-checkbox {
      flex: 0 0 0;
    }
  }
  .search-loading {
    font-size: 12px;
    text-align: center;
  }
  .no-result {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #949aae;
    text-align: center;
  }
}
</style>

<style lang="scss">
.department-dialog-search-result {
  .member-dept {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
